// Unpublished Work © 2023-2024 Deere & Company.

import {getStore} from 'Store/store';
import {setTertiaryNavBarActions} from 'Store/actions/tertiary-navbar';
import {useDeepEffect} from 'Utils/react-utils';

function useNavBarActions(actions = []) {
    useDeepEffect(() => {
        getStore().dispatch(setTertiaryNavBarActions(actions));

        return () => {
            getStore().dispatch(setTertiaryNavBarActions([]));
        };
    }, [actions]);
}

export {
    useNavBarActions
};
